module.exports = __webpack_public_path__ + "img/text-screenshot.179cbcd7.png";